import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout({ children, hideFooter = false, hideNav = false }) {
  return (
    <div className="App min-h-screen flex flex-col">
      {!hideNav && <Navbar />}
      <main className="flex-1">{children}</main>
      {!hideFooter && <Footer />}
    </div>
  );
}
